import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, Gift } from "lucide-react";
import api, { inr } from "@/lib/api";
import { ApplyForm } from "@/pages/ProductDetail";

export default function ReferLanding() {
  const { linkId } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/referral/link/${linkId}`).then((r) => setInfo(r.data)).catch(() => setErr(true));
  }, [linkId]);

  if (err) return <div className="min-h-[70vh] flex items-center justify-center text-slate-400">This referral link is invalid or expired.</div>;
  if (!info) return <div className="min-h-[70vh] flex items-center justify-center text-slate-400">Loading offer…</div>;
  const c = info.campaign, p = info.product;
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 min-h-[70vh]">
      <div className="grid lg:grid-cols-2 gap-10 items-start">
        <div>
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 font-bold px-3 py-1.5 rounded-full text-xs mb-4">
            <Gift className="w-3.5 h-3.5" /> YOU'VE BEEN REFERRED
          </div>
          <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-lg">
            <img src={c?.desktop_creative} alt={c?.name} className="w-full h-64 object-cover" />
          </div>
          <h1 className="font-display text-3xl font-extrabold text-[#0B223D] mt-6">{(p?.name) || c?.name}</h1>
          <p className="text-slate-500 mt-2 text-lg">{c?.description}</p>
          {p && (
            <ul className="mt-5 space-y-2">
              {p.features.map((x) => <li key={x} className="flex items-center gap-2 text-sm text-slate-600"><BadgeCheck className="w-4 h-4 text-teal-500" />{x}</li>)}
            </ul>
          )}
        </div>
        <div className="sticky top-24 bg-white rounded-3xl border border-slate-200 shadow-xl p-7">
          <h3 className="font-display font-bold text-xl text-[#0B223D] mb-5">Apply now</h3>
          <ApplyForm campaignId={c?.id} linkId={info.link_id} />
        </div>
      </div>
    </div>
  );
}
